import React from 'react';
import 'twin.macro';
import { LabelledDateRange } from '@teetsh/app/src/types/zone';
import { PrintProgrammation } from '../Print/PrintProgrammation';
import { shortenUUID } from '@teetsh/app/src/utils/shortenUUID';
import { useProgDisplayConfig } from 'containers/Programmations/ProgV2/atoms';
import { PrintConfig } from '../Preview/types';

interface Props {
  periodes: LabelledDateRange[];
  printConfig: PrintConfig;
}

export function Body(props: Props) {
  const { periodes, printConfig } = props;
  const { matiereIds, ...restPrintConfig } = printConfig;

  const { hiddenPeriodes, hiddenDomaines } = useProgDisplayConfig();
  return (
    <div tw="py-8 min-h-full">
      <div tw="px-6 w-full min-w-[1200px] h-full">
        <div tw="bg-white rounded-lg p-3 shadow-lg h-full">
          <div tw="w-full h-full bg-white block">
            <PrintProgrammation
              matiereIds={matiereIds.map(id => shortenUUID(id))}
              {...restPrintConfig}
              hiddenPeriodes={hiddenPeriodes}
              hiddenDomaines={hiddenDomaines}
              schoolyearPeriodes={periodes}
              hideTitle={false}
              hideMatiereTitle={false}
              editableTitle={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
